<template>
  <div class="ds-control ds-tree-selector">
    <el-row v-if="rightTree.nodeKey">
      <el-col :span="showRightBox ? 15 : 24">
        <div class="head">
          <slot name="search">
            <el-input v-model="filterText" :placeholder="placeholder" @keyup.enter.native="filterTextVal = filterText">
              <i v-if="!filtering" slot="suffix" class="iconfont icon-Magnifier" @click="filterTextVal = filterText"></i>
              <i v-else slot="suffix" class="el-icon-loading"></i>
            </el-input>
          </slot>
          <slot name="searchboxSolt"></slot>
        </div>
        <div class="content">
          <DsfTree
            v-if="slots.length == 1 && !showTab"
            ref="dsfTree"
            tab-index="0"
            :slotData="slots[0]"
          >
            <template #nodeLable="{data,node}">
              <slot name="nodeLabel" :data="data" :node="node"></slot>
            </template>
          </DsfTree>
          <el-tabs
            v-else-if="slots.length > 1 || (slots.length == 1 && showTab)"
            v-model="activeName"
            type="border-card"
          >
            <el-tab-pane
              v-for="(d, i) in slots"
              :ref="d.name"
              :key="d.name"
              :label="d.title"
              :name="d.title"
              :lazy="isDesign ? false : true"
            >
              <DsfTree
                ref="dsfTree"
                :tab-index="i"
                :slotData="d"
              >
                <template #nodeLable="{data,node}">
                  <slot name="nodeLabel" :data="data" :node="node"></slot>
                </template>
              </DsfTree>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col v-if="showRightBox" :span="9" :class="{'rightBoxIsTree':typeStyle === 'tree'}">
        <div class="head el-row">
          <el-col
            v-if="!(slots.length == 1 && typeStyle === 'tree')"
            :span="12"
            class="ellipsis"
          >
            已选择
            <b class="chooseNum" v-text="selectedData.length"></b>
          </el-col>
          <el-col
            :span="slots.length == 1 && typeStyle === 'tree' ? 24 : 12"
            class="ellipsis"
          >
            <span @click="resetSelect" class="reset">
              <i class="el-icon-refresh-right"></i>重置
            </span>
          </el-col>
        </div>
        <div class="content" ref="selectedBox">
          <DsfVirtualTree
            v-if="slots.length == 1 && typeStyle === 'tree'"
            ref="tree"
            :props="rightTree.props"
            :data="rightTree.data"
            :render-content="renderRightTreeContent"
            :default-expand-all="true"
            :node-key="rightTree.nodeKey"
          />
          <ul v-else class="list" :class="{ canSort: getSort() }">
            <li v-for="(li, i) in selectedData" :key="li._id" ref="selectedItems" :row-index="i">
              <template v-if="li._inClient">
                {{ i + 1 }}. {{ li._name }}
                <span>
                  <i
                    v-if="getSort() && i != 0"
                    class="el-icon-top"
                    title="上移"
                    @click="up(i)"
                  ></i>
                  <i
                    v-if="getSort() && i < selectedData.length - 1"
                    class="el-icon-bottom"
                    title="下移"
                    @click="down(i)"
                  ></i>
                  <i class="el-icon-close" title="删除" @click="deleted(li)"></i>
                </span>
              </template>
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default dsf.component({
  name: "DsfTreeSelector",
  ctrlCaption: "树选择器",
  mixins: [$mixins.control, $mixins.dataResult],
  props: {
    slots: {
      type: Array,
      default: function () {
        return [];
      },
    },
    placeholder: {
      //展现样式，list列表式、tree树结构
      type: String,
      default: "输入关键字进行过滤",
    },
    sort: {
      //已选数据是否可排序
      type: Boolean,
      default: false,
    },
    typeStyle: {
      //展现样式，list列表式、tree树结构
      type: String,
      default: "list",
    },
    maxLength: {
      //最大选择数量
      type: Number,
      default: 0,
    },
    showTab: {
      //只有一组数据的时候是否呈现标签样式
      type: Boolean,
      default: true,
    },
    showRightBox: {
      //是否选中右侧区域
      type: Boolean,
      default: true,
    },
    nodeKey: {
      //数据标识，部门选人组件默认是globalId
      type: String,
      default: "_id",
    },
    excludeIds: {
      //禁选节点的数据标识值 .is_excluded
      type: Array,
      default: function () {
        return [];
      },
    },
    valueNodeKey: {
      //返回的value对应的节点标识
      type: String,
      default: "_id",
    },
    filterKeyInfo: {
      // 查询条件
      type: Array,
      default() {
        return [
          {
            code: "_name",
            operation: "like"
          }
        ];
      }
    },
  },
  data() {
    /**
     * activeName: 当前选中的Tab的名称，只用于初始化打开的tab没有其余处理
     * filterText: 搜索的值
     * treesObj: 对应了每个子组件tree.vue中的element-tree的实例
     * treeSelected: 对应了每个子组件tree.vue中选中的数据
     * selectedData: 用于存储右侧选中区域显示的值
     * defaultSelect: 进入组件默认选中的集合
     */

    return {
      activeName: "",
      treesObj: [],
      treeSelected: [],
      selectedData: [],
      defaultSelect: [],
      rightTree: {
        data: [],
        props: {
          children: "children",
          label: "_name",
        },
        nodeKey: "",
        keysOfNode: {},
      },
      isCheckNodeCtrl: false,
      filterText: "",
      filtering: false,
      filterTextVal: ""
    };
  },
  watch: {
    filterTextVal(val) {
      if(this.filtering) return;
      this.filterState(true);
      let index = -1;
      for (let i in this.treesObj) {
        if(this.treesObj[i]){
          index++;
          if (dsf.type(this.$refs.dsfTree) === "array") {
            this.$refs.dsfTree[index].filter(val);
          } else {
            this.$refs.dsfTree.filter(val);
          }
        }
      }
    },
    activeName(v,n){
      if(v!=n){
        let i = _.findIndex(this.slots, function(item) { return item.title === v; });
        this.$dispatch("tabChange",{name:v,index:i})
      }
    },
    selectedData(v){
      this.$nextTick(()=>{
        this.createIntersectionObserver();
      })
    }
  },
  computed: {
    excludeIdsAll() {
      // 禁选的节点_id 集合
      return this.excludeIds.concat(this.$vm?.$attrs?.excludeIds || []);
    },
  },
  created() {
    this.init();
  },
  methods: {
    /**
     * 创建 右侧已选数据列表 观察器
     */
    createIntersectionObserver() {
      this.disconnectIntersectionObserver();
      _.each(this.selectedData, (row) => {
        this.$set(row, '_inClient', false);
      });
      if(this.selectedData.length){
        this.intersectionObserver = new IntersectionObserver(this.observerScroll,{
          root: this.$refs.selectedBox
        });
        _.each(this.$refs.selectedItems || [], (vanCell) => {
          // 开始监听
          this.intersectionObserver.observe(vanCell);
        });
      }
    },
    /**
     * 可见性发现变化时的回调函数.一般会触发两次。一次是目标元素刚刚进入视口，另一次是完全离开视口。
     */
    observerScroll(entries) {
      _.each(entries, (entry) => {
        let mark = entry.target.getAttribute("row-index");
        let row = this.selectedData[mark];
        // 目标元素与交集观察者的根节点是否相交 || 目标元素的可见比例，不可见为0
        if (row) {
          this.$set(row, '_inClient', entry.isIntersecting || entry.intersectionRatio);
        }
      });
    },
    /**
     * 关闭 右侧已选数据列表 观察器
     */
    disconnectIntersectionObserver() {
      this.intersectionObserver?.disconnect?.();
    },
    init() {
      
      this.getParentCtrlConfig();

      this.treesObj = [];
      this.treeSelected = [];
      this.selectedData = [];
      _.forEach(this.slots, (slot, index) => {
        if (index == 0) this.activeName = slot.title;
        this.treeSelected.push([]);
        this.treesObj.push(null);
      });

      this.setDefaultSelect();      
    },
    /**
     * 处理是“部门人员”组件过来——父组件配置了数据，则使用外界配置数据
     */
    getParentCtrlConfig(){
      if (
        !dsf.isEmptyObject(this.$choiceParams) &&
        _.isArray(this.$choiceParams.slots) &&
        this.$choiceParams.slots.length > 0
      ) {
        this.slots.length = this.$choiceParams.slots.length;
        for (let i in this.$choiceParams.slots) {
          this.slots[i] = this.$choiceParams.slots[i];
        }
      }
      this.rightTree.nodeKey = this.slots?.[0]?.nodeKey || this.nodeKey || "_id";
    },
    /**
     * 处理初始化默认选中
     */
    setDefaultSelect(){
      if (this.$listeners.setDefaultSelect) {
        //自定义二开设置默认选中数据
        this.$dispatch("setDefaultSelect",this._initDefaultSelect);
      } else {
        this.getDefaultSelect(this.$vm?.$attrs?.selectValue);
      }
    },
    /**
     * 整理默认选中数据-此方法用于组件还未加载完成时按加载顺序勾选中数据
     * @param {Array} list 格式：[{text:"显示文本",value:"唯一标识"}]  或者  [{_name:"显示文本",_id|globalId:"唯一标识"}]
     */
    getDefaultSelect(list) {
      if (dsf.type(list) == "array") {
        let selectValue = [];
        list.forEach(({ value, text, _name },i) => {
          let obj = dsf.mix({},list[i]);
          if(_name){
            selectValue.push(obj);
          }else if (value && text) {
            dsf.mix(obj,{
              [this.valueNodeKey]: value,
              _name: text
            });
            if (this.valueNodeKey == "globalId") {
              obj._id = _.last(value.split("."));
            }
            selectValue.push(obj);
          }
        });
        this.defaultSelect = selectValue;
      }
      this.selectedData = this.defaultSelect;
    },
    /**
     * 用于二开设置默认选中值-此方法用于组件加载完成后的修改
     * @param {Array} 形参1 [{"_id":"数据唯一标识"},{}]
     */
    _initDefaultSelect(_selectValue){
      if(this.selectedData?.length){
        this.resetSelect();
      }
      this.getDefaultSelect(_selectValue);
      let keys = _.map(this.selectedData,(obj)=>{
        return obj[this.valueNodeKey];
      })
      let index = -1;
      for (let i in this.treesObj) {
        if(this.treesObj[i]){
          index++;
          if (dsf.type(this.$refs.dsfTree) === "array") {
            this.$refs?.dsfTree?.[index]?.$refs?.tree?.setCheckedKeys(keys,false,true);
            if(this.$refs?.dsfTree?.filterText){
              this.$refs?.dsfTree?.[index]?.$refs?.tree2?.setCheckedKeys(keys,false,true);
            }
          } else {
            this.$refs?.dsfTree?.$refs?.tree?.setCheckedKeys(keys,false,true);
            if(this.$refs?.dsfTree?.filterText){
              this.$refs?.dsfTree?.$refs?.tree2?.setCheckedKeys(keys,false,true);
            }
          }
        }
      }
    },
    treeLoadData({ target, args }) {
      // 回显数据
      let _this = this;
      if (args.length && _this.defaultSelect.length) {
        target.$nextTick(() => {
          let tree = target.$refs.tree;
          tree.$nextTick(() => {
            if (_this.slots.length == 1 && _this.typeStyle === "tree") {
              // 树类型
              let defaultSelect = [];
              _.forEach(_this.defaultSelect, (obj) => {
                let node = tree.getNode(obj[target.nodeKey]);
                if (node) {
                  let obj = node.data;
                  let _globalId = obj.globalId.split(".");
                  if (!obj.treeinfo_pid && _globalId.length >= 2) {
                    obj.treeinfo_pid = _globalId[_globalId.length - 2];
                  }
                  defaultSelect.push(dsf.mix({}, obj));
                }
              });

              let temp1 = {},
                treed = [];
              for (let i = 0; i < defaultSelect.length; i++) {
                let node = defaultSelect[i];
                node.children = [];
                temp1[node._id] = node;
                if (temp1[node.treeinfo_pid]) {
                  if (!temp1[node.treeinfo_pid]["children"]) {
                    temp1[node.treeinfo_pid]["children"] = [];
                  }
                  temp1[node.treeinfo_pid]["children"].push(node);
                } else {
                  treed.push(node);
                }
              }
              _this.rightTreeData(treed);
            }
            
            // 选中数据
            _.forEach(_this.defaultSelect, (nodeData) => {
              // _this.changeNodeCheckState(target, tree, nodeData, true);
              tree.checkNode(tree.getNode(nodeData[target.nodeKey]),true,target.slotData.chooseOneNode == "1" ? true : false,false)
            });
          });
        });
      }
    },
    changeNodeCheckState(tree, treeObj, nodeData, state, deep) {
      // 切换nodeData节点,在tree中的状态为state。deep处理特定情况下的是否下转
      treeObj.setChecked(
        nodeData[tree.nodeKey],
        state,
        dsf.isUnDef(deep) ? tree.slotData.chooseOneNode == "0" ? false : true : false,
        true
      );
    },
    /**
     * 切换树节点的选中状态时 改变右侧选择数据区域集合
     */
    setSelectedData: _.debounce(function(opts) {
      let tabIndex = -1;
      if (opts) {
        if (this.slots.length == 1 && this.typeStyle === "tree") {
          this.setRightTree(opts);
          return;
        }
        tabIndex = opts.args.tabIndex;
        this.treeSelected[tabIndex] = opts.args.data;
      }

      if (this.getMaxLength() * 1 === 1) {
        this.selectedData = opts?.args?.data || [];

        _.forEach(this.treeSelected, (d, i) => {
          if (i != tabIndex) {
            this.treeSelected[i] = [];
            let tree1 = this.treesObj[i];
            if(tree1){
              _.forEach(tree1?.getCheckedNodes() || [],(t)=>{
                if(opts?.args?.data?._id != t._id){
                  tree1?.setChecked(t,false);
                }
              })
              let tree2 = tree1?.$parent?.$refs?.tree2
              if(tree2){
                _.forEach(tree2?.getCheckedNodes() || [],(t)=>{
                  if(opts?.args?.data?._id != t._id){
                    tree2?.setChecked(t,false);
                  }
                })
              }
            }
          }
        });
      } else {
        let datas = [].concat(...this.treeSelected, this.defaultSelect);
        // 去重
        datas = _.unionBy(datas, "_id");
        if (this.getSort() && this.selectedData?.length) {
          // 留住排序
          let nodeKey = this.valueNodeKey;
          let idIndexObj = {};
          _.forEach(datas,(_d)=>{
            idIndexObj[_d[nodeKey]] = _d;
          })
          
          let selectedData = [];
          _.forEach(this.selectedData, (d) => {
            // 原来的排序
            let _d = idIndexObj[d[nodeKey]];
            if(_d){
              selectedData.push(_d);
              delete idIndexObj[d[nodeKey]];
            }
          });
          _.forEach(_.keys(idIndexObj),(key)=>[
            selectedData.push(idIndexObj[key])
          ])
          this.selectedData = selectedData;
        } else {
          this.selectedData = datas;
        }
      }
    },50),
    changeNodeCheckStateAll(nodeData, state, reset) {
      // 切换nodeData节点在所在tab中的状态为state
      let index = -1;
      _.each(this.treesObj, (treeObj, i) => {
        if(treeObj){
          index++;
          let tree = "";
          if (dsf.type(this.$refs.dsfTree) === "array") {
            tree = this.$refs.dsfTree[index];
          } else {
            tree = this.$refs.dsfTree;
          }
          if(!state){
            // 删除搜索的值
            tree.deleteSearchCheckedNodes(nodeData[tree.nodeKey]);
          }
          this.changeNodeCheckState(tree, treeObj, nodeData, state);
          if (!reset) {
            //如果不是重置，才获取最新选择数据
            this.treeSelected[i] = tree.getSelectedData();
          }
        }
      });
    },
    deleted(nodeData) {
      // 右侧选中数据展示区域，单删除
      this.changeNodeCheckStateAll(nodeData, false);
      this.deleteDefaultSelect(nodeData);
      this.setSelectedData();
      this.$dispatch("deleteNode", nodeData)
    },
    deleteDefaultSelect(nodeData) {
      // 默认被选中的数据取消了选中状态特殊处理
      if (nodeData.args) {
        nodeData = nodeData.args;
      }
      let nodeKey = this.valueNodeKey;
      _.forEach(this.defaultSelect, (obj, index) => {
        if (obj[nodeKey] == nodeData[nodeKey]) {
          this.defaultSelect.splice(index, 1)
          return false;
        }
      })
    },
    //重置
    resetSelect() {
      this.isResetSelctIng = true;
      this.defaultSelect = [];
      this.selectedData = [];
      
      let index = -1;
      for (let i in this.treesObj) {
        if(this.treesObj[i]){
          index++;
          if (dsf.type(this.$refs.dsfTree) === "array") {
            this.$refs?.dsfTree?.[index]?.reset?.();
          } else {
            this.$refs?.dsfTree?.reset?.();
          }
        }
        this.treeSelected[i] = []
      }
      if (this.slots.length == 1 && this.typeStyle === "tree") {
        _.forEach(this.rightTree.data,(data)=>{
          this.$refs.tree.remove(data)
        })
        this.rightTree.data = [];
      }
      this.isResetSelctIng = false;
    },
    reloadData() {
      this.resetSelect();
      this.treesObj = [];
      this.treeSelected = [];

      let dsfTree = this.$refs.dsfTree;
      if (dsf.type(dsfTree) === "array") {
        dsfTree.forEach((t) => t.reloadData());
      } else {
        dsfTree.reloadData();
      }
    },
    getSort() {
      if (this.$choiceParams && dsf.isDef(this.$choiceParams.sort)) {
        return this.$choiceParams.sort;
      }
      return this.sort;
    },
    getMaxLength() {
      if (this.$choiceParams && dsf.isDef(this.$choiceParams.maxLength)) {
        return this.$choiceParams.maxLength;
      }
      return this.maxLength;
    },
    setTreeObj(treeVm) {
      // 右侧的选择数据被删除时，需要同步修改树节点的选择状态
      this.$set(this.treesObj,treeVm.tabIndex,treeVm.$refs.tree);
      treeVm.filterText = this.filterText;
      this.$dispatch("treeInited",treeVm);
    },
    up(i) {
      // 上移
      if (i > 0) {
        let curr = this.selectedData[i];
        let currIndex = i;
        dsf.array.remove(this.selectedData, curr);
        this.selectedData.splice(currIndex - 1, 0, curr);
      }
    },
    down(i) {
      // 下移
      if (this.selectedData.length - 1 > i) {
        let curr = this.selectedData[i];
        let currIndex = i;
        dsf.array.remove(this.selectedData, curr);
        this.selectedData.splice(currIndex + 1, 0, curr);
      }
    },
    getReturnValue() {
      const self = this;
      let datas = [];
      if (
        this.getMaxLength() * 1 > 0 &&
        this.selectedData.length > this.getMaxLength() * 1
      ) {
        dsf.layer.message(
          "已超出选择数量上限【" + this.getMaxLength() + "】",
          false
        );
        return false;
      }
      for (let i in this.selectedData) {
        let obj = {};
        obj = {
          value: self.selectedData[i][this.valueNodeKey],
          text: self.selectedData[i]._name,
        };
        let index = _.findIndex(datas, (it) => {
          return it.value == obj.value;
        });
        if (index < 0) {
          datas.push(dsf.mix(obj, this.selectedData[i]));
        }
      }
      return datas;
    },
    renderRightTreeContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span>{node.label}</span>
          <span class="custom-tree-node_del" style="margin-left:16px">
            <i
              class="el-icon-close"
              title="删除"
              on-click={() => this.removeNode(node, data)}
            ></i>
          </span>
        </span>
      );
    },
    removeNode(node, data) {
      this.$refs.tree.remove(node);
      let deletes = [];
      this.removeNodeChild(deletes, data);
      this.selectedData = _.differenceBy(this.selectedData, deletes, "_id");
    },
    removeNodeChild(arr, d) {
      arr.push(d);
      _.forEach(d.children, (n) => {
        this.removeNodeChild(arr, n);
      });
    },
    setRightTree(opts) {
      let node = opts.args.data;
      if(node.data){
        let data = dsf.mix({}, node.data);
        if (this.slots[0].chooseOneNode == "0") {
          data["children"] = [];
        }
        let nodePath = [];
        _.forEach(this.treesObj[0].getNodePath(node.data[this.rightTree.nodeKey]),(node)=>{
          if(!dsf.isEmptyObject(node)){
            nodePath.push(dsf.mix(true,{},node))
          }
        })
        if(nodePath?.length) this.rightTreeData(nodePath);
      }
    },
    rightTreeData(nodePath) {
      let temp;
      let loaded = false;
      if(this.$refs?.tree){
        _.forEachRight(nodePath, (node, i) => {
          let _node = this.$refs.tree.getNode(node[this.rightTree.nodeKey]);
          if (_node && this?.selectedData?.length) {
            if (temp) this.$refs.tree.append(temp, _node);
            loaded = true;
            return false;
          } else {
            if (temp) {
              node.children = [temp];
            }
            temp = node;
          }
        });
      }
      if (!loaded) {
        this.rightTree.data = temp ? [temp] : [];
      }

      let datas = [].concat(this.selectedData, nodePath);
      // 去重
      datas = _.unionBy(datas, "_id");

      this.selectedData = datas;
    },
    checkNode(opts) {
      this.$dispatch("getCheckNode", opts);
    },
    filterState(state){
      this.filtering = !!state;      
    }
  },
  design: {
    isMask: true, //调试模式为false,调试完后会改为true
    fit: true,
  },
  provide(){
    return {
      $treeBox: this
    }
  },
  beforeDestroy() {
    this.disconnectIntersectionObserver();
  },
});
</script>
